import { createContext, useContext } from 'react';

export function setupMobX<Store>() {
  const Context = createContext({} as Store);

  const Provider = ({
    children,
    store,
  }: {
    children: React.ReactNode;
    store: Store;
  }) => {
    return <Context.Provider value={store}>{children}</Context.Provider>;
  };

  return {
    useStore: () => useContext<Store>(Context),
    provider: Provider,
  };
}
